import {StateCreator} from 'zustand'

export interface GamePauseSlice {
    gamePause: {
        isPaused: boolean
        setIsPaused: (isPaused: boolean) => void
        remainingPauseTimeMS?: number | undefined
        setRemainingPauseTimeMS: (remainingPauseTimeMS: number | undefined) => void
        togglePause: () => void
    }
}

export interface GamePauseSliceProps {
    togglePause: () => void
}

export const createGamePauseSlice = ({
    togglePause,
}: GamePauseSliceProps): StateCreator<GamePauseSlice> => (set, get) => ({
    gamePause: {
        isPaused: false,
        setIsPaused: (isPaused: boolean) => {
            set({
                gamePause: {
                    ...get().gamePause,
                    isPaused: isPaused,
                },
            })
        },
        remainingPauseTimeMS: undefined,
        setRemainingPauseTimeMS: (remainingPauseTimeMS: number | undefined) => {
            set({
                gamePause: {
                    ...get().gamePause,
                    remainingPauseTimeMS: remainingPauseTimeMS,
                },
            })
        },
        togglePause: togglePause,
    },
})
